var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":_vm.formatBatteryPercentage}},[_c('i',{class:['fad', _vm.formatBatteryIcon],style:({
      '--fa-primary-color': _vm.primaryColor,
      '--fa-secondary-color': _vm.secondaryColor,
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }